import { observer } from 'mobx-react';
import ParticipantStore from '../../../../../../ParticipantStore';
import Loader from '../../../../../Loader';
import { AddLicenseToParticipantsStore } from '../Store';
import LoadingErrorView from './LoadingErrorView';
import ReadyView from './ReadyView';
import SubmittingErrorView from './SubmittingErrorView';
import { ModalFormState } from './Types';

interface Props {
  state: ModalFormState;
  checkedParticipants: ParticipantStore[];
  submitting: () => void;
  store: AddLicenseToParticipantsStore;
}

function Body({ state, submitting, checkedParticipants, store }: Props) {
  switch (state.kind) {
    case 'loading':
      return <Loader className="h-full" />;
    case 'loading-error':
      return <LoadingErrorView state={state} />;
    case 'initial-ready':
    case 'fetching-license-options':
    case 'licenses-ready':
      return (
        <ReadyView
          state={state}
          submitting={submitting}
          checkedParticipants={checkedParticipants}
          store={store}
        />
      );
    case 'fetching-license-options-error':
      return <LoadingErrorView state={{ kind: 'loading-error', error: state.error }} />;
    case 'submitting':
      return <Loader className="h-full" />;
    case 'submitting-error':
      return <SubmittingErrorView state={state} />;
  }
}

export default observer(Body);
